import React, { useCallback, useMemo, useRef } from 'react';
import { FlatListProps, StyleSheet } from 'react-native';
import { FlatList } from 'react-native-gesture-handler';

import { useIsFocused } from '@react-navigation/native';

import { useSbkBetSlipStore } from '@/feature/betslip-sbk/hooks/use-sbk-betslip-store';
import { useScrollToEditBet } from '@/feature/betslip-sbk/hooks/use-scroll-to-edit-bet';
import { common } from '@/styles/styles';
import { isAndroid } from '@/utils/constants-platform-specific';

import { ACTION_TRAY_MAX_HEIGHT } from './betslip-action-tray/BetSlipActionTray';
import { SinglesCard } from './singles-card/SinglesCard';

export const CLEAR_BUTTON_HEIGHT = 32;

const BASE_BOTTOM_PADDING = ACTION_TRAY_MAX_HEIGHT + CLEAR_BUTTON_HEIGHT + (isAndroid ? 32 : 16);

export const betSlipTabStyle = StyleSheet.create({
    root: { paddingVertical: 24 },
});

type SinglesListProps = Pick<FlatListProps<string>, 'ListHeaderComponent' | 'ListFooterComponent'>;

export const SinglesList = ({ ListHeaderComponent, ListFooterComponent }: SinglesListProps) => {
    const selectionIds = useSbkBetSlipStore(state => state.selectionOrder);
    const flatListRef = useRef<FlatList<string>>(null);
    const isFocused = useIsFocused();
    const { handleItemLayout, handleListLayout, keyboardHeight } = useScrollToEditBet(flatListRef, isFocused);

    const contentContainerStyle = useMemo(
        () => ({
            paddingBottom: isAndroid && keyboardHeight > 0 ? BASE_BOTTOM_PADDING + keyboardHeight : BASE_BOTTOM_PADDING,
        }),
        [keyboardHeight]
    );

    const renderItem = useCallback(
        ({ item }: { item: string }) => {
            return <SinglesCard selectionId={item} onItemLayout={handleItemLayout} />;
        },
        [handleItemLayout]
    );

    return (
        <FlatList
            ref={flatListRef}
            onLayout={handleListLayout}
            style={[betSlipTabStyle.root, common.paddingHorizontal]}
            contentContainerStyle={contentContainerStyle}
            data={selectionIds}
            renderItem={renderItem}
            keyExtractor={item => item}
            keyboardShouldPersistTaps="always"
            ListHeaderComponent={ListHeaderComponent}
            ListFooterComponent={ListFooterComponent}
        />
    );
};
